<template lang="pug">
  .banners.fixed.md-sticky.z-30.md-z-10.top-0.md-top-auto.md-bottom-0.left-0.md-mt-10.w-full

    //- IE
    banner.bg-blue.text-white(v-if="showIE")
      p(slot="text")
        | Your web browser is out of date and may not support this website. Please consider updating&nbsp;it. For&nbsp;any enquiries, please contact <a href="mailto:info@bluemountain.school" target="_blank" rel="noopener">info@bluemountain.school</a> or +44 (0)20 7739 9733.
      button(slot="button", @click="showIE = false").w-full.h-82.flex.items-center.justify-center.border.border-current Close

    //- Cookies
    banner.bg-white.border-b.md-border-b-0.md-border-t(v-if="!acceptedCookies && cookiePolicyLink")
      p(slot="text")
        | We are using cookies to offer a better online experience. You can read our <wp-link :link="cookiePolicyLink" class="hover-text-blue">cookies policy</wp-link>
      button.w-full.h-82.flex.items-center.justify-center.border.hover-text-blue.hover-border-current.trans-fast(slot="button", @click="acceptCookies") Accept
</template>

<script>
import { mapState } from 'vuex'
import Banner from './Banner'
import wpLink from '@/components/WPLink'
export default {
  name: 'Banners',
  data () {
    return {
      showIE: this.isIE()
    }
  },
  computed: {
    ...mapState(['site', 'acceptedCookies']),
    cookiePolicyLink () {
      return this.site && this.site.privacy_policy_link
    }
  },
  methods: {
    acceptCookies () {
      this.$store.commit('ACCEPT_COOKIES')
    },
    isIE () {
      /*
       * Function to detect IE11 or below
       * @returns version number or false
      */
      var ua = window.navigator.userAgent
      // IE 10 or older => return version number
      var msie = ua.indexOf('MSIE ')
      if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
      }
      // IE 11 => return version number
      var trident = ua.indexOf('Trident/')
      if (trident > 0) {
        var rv = ua.indexOf('rv:')
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
      }
      return false
    }
  },
  components: { Banner, wpLink }
}
</script>

<style>
</style>
